export default __webpack_public_path__ + "static/media/people.3c76e7e0.jpg";